module.exports = "<h1 id=\"24-无--何もしない\">24. 无 / 何もしない</h1>\n<p><strong><code>Nop</code>、什么都不做。</strong></p>\n";